export default __webpack_public_path__ + "static/media/C.b68dba8a.svg";